// Server-rendered pricing stays authoritative. Only the display window is timed here.
class DwilPdpPromotion extends HTMLElement {
  #timer;
  connectedCallback() {
    this.#update();
    document.addEventListener('visibilitychange', this.#update);
  }
  disconnectedCallback() {
    clearTimeout(this.#timer);
    document.removeEventListener('visibilitychange', this.#update);
  }
  #update = () => {
    clearTimeout(this.#timer);
    const start = Number(this.dataset.startsAt) * 1000;
    const end = Number(this.dataset.endsAt) * 1000;
    const now = Date.now();
    const active = (!start || now >= start) && (!end || now < end);
    const content = this.querySelector('[data-promo-content]');
    const fallback = this.querySelector('[data-promo-fallback]');
    if (content) content.hidden = !active;
    if (fallback) fallback.hidden = active;
    const countdown = this.querySelector('[data-promo-countdown]');
    const time = countdown?.querySelector('[data-promo-time]');
    const counting = active && Number.isFinite(end) && end > now && Boolean(time);
    if (countdown) countdown.hidden = !counting;
    if (counting) {
      const remaining = Math.ceil((end - now) / 1000);
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      const pad = value => String(value).padStart(2, '0');
      time.textContent = `${pad(days)}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
      time.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);
    }
    // Resume from the absolute deadline on return; no background second-by-second work.
    if (document.hidden) return;
    const next = start > now ? start : end > now ? end : 0;
    if (next) this.#timer = setTimeout(this.#update, Math.min(next - now + 20, counting ? 1000 : 2147483647));
  };
}
if (!customElements.get('dwil-pdp-promotion')) {
  customElements.define('dwil-pdp-promotion', DwilPdpPromotion);
}
